import AdminSimpleManager from "./AdminSimpleManager";

const fields = [
  { name: "question", label: "Question" },
  { name: "answer", label: "Answer", type: "textarea" },
  { name: "sort_order", label: "Sort order", type: "number" },
  { name: "active", label: "Active", type: "checkbox" },
];

export default function AdminFaqs() {
  return (
    <AdminSimpleManager
      title="FAQs"
      eyebrow="Content"
      endpoint="/api/faqs"
      fields={fields}
      emptyItem={{ question: "", answer: "", sort_order: 0, active: true }}
      labelField="question"
    />
  );
}
